import { kftMicroDown } from '~/utils/kft-micro-down'

/**
 * Parses a CMS FAQ answer as markdown (same parser as the magazine article
 * body) so editors can add links, lists and paragraphs.
 */
export const parseFaqAnswer = <T extends string | null | undefined>(
  answer: T
): T | string => (answer ? kftMicroDown.parse(answer) : answer)
